// tslint:disable:no-reference
/// <reference path="../../bootstrap/load-terrific.ts" />
// tslint:enable:no-reference

import * as $ from 'jquery';
import { Module } from 'lib/vendor/terrific/Module';
type JQueryInitable = JQuery | string | Element | Element[];

// Cache the result for the page (it never changes)
let pageIsMobile : boolean | undefined;

const MOBILE_SELECTOR = 'div.mobile, body.is-mobile';
export function isMobilePage($ctx? : JQuery) {
	if ($ctx && $ctx.length > 0) {
		return $ctx.find(MOBILE_SELECTOR).length > 0;
	}

	if(!document.body) {
		const e = new Error('isMobilePage called too early, no body yet');
		setTimeout(() => {
			throw e;
		}, 0);

		return false;
	}

	if(pageIsMobile === undefined) {
		pageIsMobile = $(MOBILE_SELECTOR).length > 0;
	}

	return pageIsMobile;
}

declare global {
	interface Window {
		CQ : any;
	}
}

export function isEditMode() {
	return !!(
		(window.CQ
			&& window.CQ.WCM
			&& window.CQ.WCM.isEditMode
			&& window.CQ.WCM.isEditMode(true)
		) || document.body.dataset.editMode);
}

export function zeroFill(num : any, length = 2) {
	length -= Math.round(num).toString().length;

	return new Array((length > 0 ? length + 1 : 0)).join('0') + num;
}

/**
 * Returns a unique id for the given DOM element. This id does not change if it is set once.
 * @method getUniqueIdOfElement
 * @param {HTMLElement|jQuery} element
 * @returns {String}
 */
let counter = 0;
export function getUniqueIdOfElement(element : JQueryInitable) : string {
	const $el = $(element as string);
	let id = $el.data('unique-element-id');

	if(!id) {
		counter++;
		id = counter;
		$el.data('unique-element-id', id);
	}

	return id;
}

/**
 * @method isNumber
 * @param value
 * @returns {boolean}
 */
export function isNumber(value : any) : boolean {
	return !isNaN(parseInt(value, 10));
}

declare interface IGeolocation {
	swissvisitor : boolean;
	euvisitor : boolean;
}

declare global {
	interface Window { geolocation : IGeolocation; }
}

export function isSwissVisitor() : boolean {
	/* Our test enviorments does not have these option, so always return true in
	 case there is no window.geolocation object */
	return !window.geolocation || window.geolocation.swissvisitor;
}

export function sanitizePhone(to : string) : string {
	if(!to) {
		return '';
	}
	to = to.replace(/[\s*\-?\\?\/?\(?\)?]/g, '');
	if(to.indexOf('+') !== 0) {
		if(to.indexOf('00') === 0) {
			to = to.slice(2);
		}
		if(to.indexOf('0') === 0) {
			to = `41${to.slice(1)}`;
		}
		to = `+${to}`;
	}

	return to;
}

export function namespace(ns : string, curr : any = window) {
	ns.split('.').forEach(function(item) {
		if(!(item in curr)) {
			curr[item] = {};
		}
		curr = curr[item];
	});

	return curr;
}

/*
 * Implementation for the SCS.ensure method and the “scs-element-add” event
 * The choice for ensure vs the event is entirely up to you.
 * See below for whether to use these or a Tc.Module.
 *
 * SCS.ensure method: alternative to jQuery(document).ready.
 * “scs-element-add” event: event-based API for the same functionality.
 *
 * Called with static content as well as lazily-loaded elements.
 *
 * There are two ways of using ensure (often you’ll use both in the same component):
 *
 * 1. You’re loading content whose components need to be initialized
 *
 * When developing a lazily-loading component (that does not use the overloaded $(…).load()),
 * just call
 * `SCS.utils.initNewModules(element)` (preferred method because it works on bluewin as well whereas ensure doesn’t)
 * or
 * `SCS.ensure(element)`
 * or
 * `$(element).trigger('scs-element-add')`
 * as soon as the loaded element has been updated,
 * with `element` being the updated/newly-loaded element.
 *
 * 2. You’re developing a component that wants to be initialized
 *
 * Instead of
 * $(document).ready(function($){
 *	$('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * });
 * use
 * SCS.ensure(function($context, $) {
 *	$context.find('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * });
 * or, using the events
 * $(document).on('scs-element-add', function(event) {
 *	$context = $(event.target || document);
 *	$context.find('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * })
 *
 * Note: Do NOT use this function if not strictly necessary (eg. to do stuff that only has to be done
 * once, like binding events to a specific element) because all ensired listeners are called
 * each time a load occures. This leads to performance problems if there are lots of
 * listeners that, when called, search the DOM for elements to process each time.
 *
 * For simple event listerns just use the jQuery "delegate" function (or "on" with newer jQuery versions).
 *
 * To prevent performance problems you can additionally pass a DOM-element or a
 * css-selector-string as second parameter along with your callback-function to make
 * sure the function gets only called when a element is loaded which matches the selector.
 * If you don’t pass this additional parameter your callback-function gets called
 * every time ANY load-event is fired (including the DOM-ready event).
 *
 * An example for the selector could be 'body, .ui-tabs-panel, .ui-dialog-content':
 *
 * SCS.ensure(function($context, $) {
 *	$context.find('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * }, 'body, .ui-tabs-panel, .ui-dialog-content');
 * or, using the events
 * $(document).on('scs-element-add', 'body, .ui-tabs-panel, .ui-dialog-content', function(event) {
 *	$context = $(event.target || document);
 *	$context.find('.some_css_class').each(function () {
 *		// some fancy stuff here
 *	});
 * })
 *
 * This used to be the only method to reliably initialize widgets on lazily-loaded content.
 * However, now there are Tc.Modules and the 'scs-element-add' events,
 * all of which can be used, depending on use cases.
 *
 * Tc.Modules are applicable for encapsulated widgets,
 * ensure or the 'scs-element-add' event can be used
 * for commonly-used light-weight components with few dependencies.
*/

const SCS = namespace('SCS');
const utils = namespace('utils', SCS);

function initNewModulesImpl(container : JQueryInitable, scope? : EnsureCycleOrigin) : Module[] {
	if (scope === initNewModulesImpl) {
		// `initNewModules` calls going in circles, stopping now
		return [];
	}
	const $ctx = $(container as string);

	// Do jQuery Mobile module initialization (if applicable).
	// Should be done before initializing Tc.Modules because they sometimes rely on the correct DOM being already present.
	if('enhanceWithin' in $.fn) {
		($ctx as any).enhanceWithin();
	}

	// Remove the flag on the container which tells Terrific to not initialize the descending modules
	if ($ctx.attr('data-ignore-descendants') === 'true') {
		$ctx.removeAttr('data-ignore-descendants').removeData('ignore-descendants');
	}

	let modules : Module[] = [];

	// Init all Terrific modules in this container
	if (window.application && window.application.sandbox) {
		modules = window.application.sandbox.addModules($ctx);
	}

	// Init all ensured modules in this container
	ensure($ctx, scope || initNewModulesImpl);

	return modules;
}

let initNewModules = initNewModulesImpl;
if(!('initNewModules' in utils)) {
	utils.initNewModules = initNewModulesImpl;
} else {
	initNewModules = utils.initNewModules as typeof initNewModulesImpl;
}

export { initNewModules };

type EnsureCycleOrigin = ((...args : any[]) => any) | undefined;

interface EnsureHandler {
	(ensured : JQuery, $ : JQueryStatic) : void;
}


const handlers : [EnsureHandler, JQueryInitable | false | undefined][] = [];

function ensureImpl(context : JQueryInitable, flags? : EnsureCycleOrigin | false) : JQuery | true;
function ensureImpl(handler : EnsureHandler, scope? : JQueryInitable | false) : void;
function ensureImpl(
	handler : JQueryInitable | EnsureHandler,
	scope? : EnsureCycleOrigin | JQueryInitable | false,
) : JQuery | undefined | true {
	if(handler && typeof handler === 'function') {
		/*
			Function given, alias for $(document).on('scs-element-add', function() {
				handler($(event.target), $);
			})
		*/
		handlers.push([handler, scope] as [EnsureHandler, JQuery | false | undefined]);

		return undefined;
	}
	if(scope as any === ensureImpl) {
		// Ensure calls going in circles, stopping now
		return undefined;
	}
	const $el = $(handler as string);

	// Check if element is inside the document (some functions e.g. size-measuring do not work otherwise)
	const $elBody = $el.closest('body');
	if ($el[0] !== document.body && $el[0] as Node !== document && (!$elBody.length || $elBody[0] !== document.body)) {
		return true;
	}
	const ignoreScope = scope === false;
	if(ignoreScope) {
		scope = undefined;
	}

	// Call handlers
	const errorStack : Error[] = [];
	for(const [myHandler, myScope] of handlers) {
		// In a try statement because js-errors in these functions
		// Should not be able to stop execution of all other functions in the queue
		try {
			// `scope === false` is a special case, meaning scoping restrictions should be ignored (for overlays and the like)
			// `!myScope` means the handler was registered for all scopes
			// `myScope === $el[0]` means the scope for the handler is an element
			// `(myScope.length && $el.is(myScope))` for the case where the scope is a selector
			if (ignoreScope || !myScope || myScope === $el[0] || ((myScope as any).length && $el.is(myScope))) {
				myHandler($el, $);
			}
		} catch (err) {
			errorStack.push(err);
		}
	}
	/* debug.log('commons.js > ensure > triggered scs-element-add event', $el.prop('tagName'), $el.attr('class')); */
	if(scope as any !== addHandler) {
		$el.trigger('scs-element-add', scope || ensureImpl);
	}

	$.each(errorStack, function(_i, error) {
		// Set a timeout so the calling method is not affected by the error
		window.setTimeout(function() {
			// Throw error because the user should be able to see the error if it occured
			throw error;
		}, 1);
	});

	return $el;
}

let ensure = ensureImpl;
if(!('ensure' in SCS)) {
	SCS.ensure = ensureImpl;
} else {
	ensure = SCS.ensure as typeof ensureImpl;
}

export { ensure };

/**
 * Handle 'scs-element-add' events appropriately.
 *
 * Note that this is added only after triggering the first 'scs-element-add' on DOM ready
 * because Terrific already initializes modules on DOM ready and PIE also kicks in immediately.
 * Only ensure had to be triggered manually, which we did above.
 */
const $doc = $(document);

function addHandler(event : Event, scope : EnsureCycleOrigin) {
	if(scope === addHandler) {
		// `addHandler` calls going in circles, stopping now
		return;
	}
	const $el = $(event.target || $doc) as JQuery;

	/**
	 * Initialize Tc.Modules on 'scs-element-add' (when elements have been added).
	 */
	initNewModules($el, scope || addHandler);
}

/*
 * Trigger 'scs-element-add' on DOM ready.
 *
 * The 'scs-element-add' event is completely compatible with ensure, which acts as a more type-safe synonym:
 *
 * • $el.trigger('scs-element-add') is the same as SCS.ensure($el)
 * • $(document).on('scs-element-add', fn) is the same as SCS.ensure(fn) (with the prepended `event` argument to fn).
 * • $(document).on('scs-element-add', '.selector', fn) is the same as SCS.ensure(fn, '.selector')
 *                                                      (with the prepended `event` argument to fn).
 */
$doc.off('.helpers').on('ready.helpers', function() {
	ensure(document.body);
	$doc.trigger('scs-element-add');

	/**
	 * Handle 'scs-element-add' events appropriately.
	 *
	 * Note that this is added only after triggering the first 'scs-element-add' on DOM ready
	 * because Terrific already initializes modules on DOM ready and PIE also kicks in immediately.
	 * Only ensure had to be triggered manually, which we did above.
	 */

	$doc.on('scs-element-add.helpers', addHandler as any);
});

/**
 * Wait for image to be loaded. Work around issue when image is loaded from cache.
 */
export function imageLoaded(image : HTMLImageElement) {
	return new Promise(function(resolve, reject) {
		if(image.complete) {
			resolve(image);
		}
		function unbind() {
			image.removeEventListener('load', loaded);
			image.removeEventListener('error', rejected);
		}
		const loaded = function() { unbind(); resolve(image); };
		const rejected = function(event : ErrorEvent) { unbind(); reject(event.error); };
		image.addEventListener('load', loaded);
		image.addEventListener('error', rejected);
	});
}


/**
 * Gets the fetch API.
 * On IE 11, waits until the polyfill is available (provided by Shared Header or SDX webcomponents)
 */
export async function fetcher() {
	if(window.fetch) {
		return window.fetch;
	}

	return new Promise<typeof fetch>(resolve => {
		const interval = window.setInterval(() => {
			if(window.fetch) {
				clearInterval(interval);
				resolve(window.fetch);
			}
		}, 50);
	});
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/util/helpers.ts